import { render, staticRenderFns } from "./newComment.vue?vue&type=template&id=1b56757c&scoped=true"
import script from "./newComment.vue?vue&type=script&lang=js"
export * from "./newComment.vue?vue&type=script&lang=js"
import style0 from "./newComment.vue?vue&type=style&index=0&id=1b56757c&prod&lang=less&scoped=true"
import style1 from "./newComment.vue?vue&type=style&index=1&id=1b56757c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b56757c",
  null
  
)

export default component.exports